import { CSSProperties, ReactNode } from "react";
import cn from "classnames";
import { TooltipPlacement } from "antd/es/tooltip";
import { CustomTooltip } from "./CustomTooltip";

import styles from "./TitleField.module.scss";
import { MobileTooltip } from "../MobileTooltip/MobileTooltip";

const isRenderTooltipAlwaysByTypeField = (typeField?: string) => {
  if (!typeField) return false;
  return ["radio", "checkbox", "uploadFile"].includes(typeField);
};

interface TitleField {
  name?: string;
  required?: boolean;
  tooltip?: string;
  isColon?: boolean;
  styleContainer?: CSSProperties;
  styleText?: CSSProperties;
  placement?: TooltipPlacement;
  typeField?: string;
  icon?: ReactNode;
}

export const TitleField = ({
  name,
  required = false,
  tooltip = "",
  isColon = true,
  styleContainer,
  styleText,
  placement,
  typeField,
  icon,
}: TitleField) => {

  return (
    <div className={styles.container} style={styleContainer}>
      <div className={styles.containerTitle} style={styleContainer}>
        <h3 className={cn({ [styles.text]: required })} style={styleText}>
          {name}
          {isColon && ":"}
        </h3>
        <CustomTooltip
          tooltip={tooltip}
          placement={placement}
        />
        {icon && <span className={styles.titleIcon}>{icon}</span>}
      </div>
      {isRenderTooltipAlwaysByTypeField(typeField) && <MobileTooltip content={tooltip} />}
    </div>
  );
};
